<template>
  <div>
    <v-container grid-list-xl class="word-wrap">
      <v-layout row wrap justify-center mt-5>
        <!-- Feeds-->
        <v-flex
          xs12
          md8
          sm12
          justify-center
          align-center
          style="max-width: 670px"
        >
          <card-menu
            v-for="(item, i) in items"
            :key="i"
            class="mr-3 ml-3 mb-6"
            style="float: left"
            :item="item"
          />
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import CardMenu from "../../components/Menu/CardMenu.vue";
export default {
  data: () => {
    return {
      items: [
        {
          color: "#1F7087",
          icon: "newcomers.png",
          title: "Yeni Katılanlar",
          to: "/newComers",
          isAdmin: false,
        },
        {
          color: "#1F7087",
          icon: "birthday.png",
          title: "Bugün Doğanlar",
          to: "/bornTodayUsers",
          isAdmin: false,
        },
        {
          color: "#1F7087",
          icon: "whosWho.png",
          title: "Kim Kimdir",
          to: "/whosWho",
          isAdmin: false,
        },
        {
          color: "#1F7087",
          icon: "bestOfBsp.png",
          title: "BSP'nin Enleri",
          to: "/bestOfUsers",
          isAdmin: false,
        },
        {
          color: "#1F7087",
          icon: "communityApplications.svg",
          title: "Topluluk Uygulamaları",
          to: "/otherApplication",
          isAdmin: false,
        },
        {
          color: "#1F7087",
          icon: "thanks.png",
          title: "Teşekkür Et",
          to: "/thanksForm",
          isAdmin: false,
        },
        {
          color: "#1F7087",
          icon: "liveArchive.png",
          title: "Canlı Yayın Arşiv",
          to: "/liveStreamArchive",
          isAdmin: false,
        },
        {
          color: "#1F7087",
          icon: "liveRequest.png",
          title: "Canlı Yayın İstekleri",
          to: "/liveStreamRequest",
          isAdmin: true,
        },
        {
          color: "#1F7087",
          icon: "survey.png",
          title: "Anketlerim",
          to: "/surveyList",
          isAdmin: false,
        },
        {
          color: "#1F7087",
          icon: "rebates.svg",
          title: "İlanlar",
          to: "/adverts",
          isAdmin: false,
        },
        {
          color: "#1F7087",
          icon: "survey.png",
          title: "Anketlerim",
          to: "/surveyList",
          isAdmin: false
        },
        {
          color: "#1F7087",
          icon: "rebates.svg",
          title: "İlanlar",
          to: "/adverts",
          isAdmin: false
        }
      ],
    };
  },
  components: {
    CardMenu,
  },
  methods: {},
  computed: {},
  destroyed() {},
  mounted() {},
  watch: {},
};
</script>

<style>
.gradientBg {
  background: rgb(162, 155, 254);
  background: linear-gradient(
    00deg,
    rgba(162, 155, 254, 1) 0%,
    rgba(255, 118, 117, 1) 100%
  );
}
</style>
